import useOperatingSystems from '../../../../hooks/useOperatingSystems'
import SystemRequirementBox from './SystemRequirementBox'

const SystemRequirementsSection = ({
  minimumSystemRequirement,
  setMinimumSystemRequirement,
  recommendedSystemRequirement,
  setRecommendedSystemRequirement,
}) => {
  const osOptions = useOperatingSystems()

  return (
    <div className="systemRequirements">
      <SystemRequirementBox
        title="حداقل سیستم مورد نیاز"
        value={minimumSystemRequirement}
        onChange={setMinimumSystemRequirement}
        osOptions={osOptions}
      />
      <SystemRequirementBox
        title="سیستم مورد نیاز پیشنهادی"
        value={recommendedSystemRequirement}
        onChange={setRecommendedSystemRequirement}
        osOptions={osOptions}
      />
    </div>
  )
}

export default SystemRequirementsSection
